module.exports = __webpack_public_path__ + "img/layout_bottom_1.ab08e18b.png";